import { Link } from 'react-router-dom';

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Donovan Y',
      location: 'Google Review',
      rating: 5,
      text: 'Sincerely the absolute top amazing people and services that I have ever experienced in my 33 years in the entertainment industry. Staff treats you like family. The Clown is world famous, kindest, loving, compassionate, considerate. They have given me good memories that will never fade.',
      avatar: 'https://ui-avatars.com/api/?name=Donovan+Y&background=DC2626&color=fff'
    },
    {
      name: 'Roxann P',
      location: 'Facebook Review',
      rating: 5,
      text: 'I would like to thank Fun Affairs for the amazing job they did for the end of the year bash for Paxinosa. Everyone was so helpful with our planning and exceeded our expectations. I would recommend them to anyone. Look forward to working with you in the future.',
      avatar: 'https://ui-avatars.com/api/?name=Roxann+P&background=DC2626&color=fff'
    },
    {
      name: 'Cindi K',
      location: 'Facebook Review',
      rating: 5,
      text: 'Always a great performance by Balloons the Clown. They\'ve supplied our event for many many years. Professional place but yet down to earth and friendly! Everything always ran smoothly! Thanks Fun Affairs!',
      avatar: 'https://ui-avatars.com/api/?name=Cindi+K&background=DC2626&color=fff'
    },
    {
      name: 'Chelsea M',
      location: 'Facebook Review',
      rating: 5,
      text: 'Thank you to Neal and Fun Affairs for making my daughter\'s 4th birthday spectacular!! The bounce house was a huge hit and the service was outstanding. Highly recommend!',
      avatar: 'https://ui-avatars.com/api/?name=Chelsea+M&background=DC2626&color=fff'
    },
    {
      name: 'YMCA Of Easton',
      location: 'Facebook Review',
      rating: 5,
      text: 'We are sending a BIG THANK YOU to Fun Affairs for donating a dozen cakes for our Campers! They all loved being little "professional cake decorators" and made an awesome camp memory together!',
      avatar: 'https://ui-avatars.com/api/?name=YMCA&background=DC2626&color=fff'
    },
    {
      name: 'Sarah T',
      location: 'Google Review',
      rating: 5,
      text: 'Fun Affairs made our corporate event a huge success! The interactive games were perfect for team building and everyone had a blast. Professional setup and takedown. Will definitely use them again!',
      avatar: 'https://ui-avatars.com/api/?name=Sarah+T&background=DC2626&color=fff'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-red-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Sora, sans-serif' }}>
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-6">
            Don't just take our word for it. See what our satisfied customers have to say about their experience with Fun Affairs.
          </p>
          <div className="flex items-center justify-center space-x-2 mb-4">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="ri-star-fill text-3xl text-amber-500"></i>
            ))}
          </div>
          <p className="text-lg font-semibold text-gray-900">5.0 out of 5 stars from 150+ reviews</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center space-x-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xl text-amber-500"></i>
                ))}
              </div>
              <p className="text-sm text-gray-700 mb-6 leading-relaxed">
                "{testimonial.text}"
              </p>
              <div className="flex items-center space-x-3">
                <img 
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full"
                />
                <div>
                  <p className="font-bold text-gray-900 text-sm">{testimonial.name}</p>
                  <p className="text-xs text-gray-600">{testimonial.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/reviews" 
            className="inline-block bg-red-600 text-white px-8 py-4 rounded-full text-base font-bold hover:bg-red-700 transition-colors whitespace-nowrap"
          >
            Read More Reviews
          </Link>
        </div>
      </div>
    </section>
  );
}